import * as BABYLON from 'babylonjs';
import Vec3 from "../../../shared/vec3";
import AbstractMesh = BABYLON.AbstractMesh;
import { loadAsset } from "../rendering/helper";
import { AssetIdentifiers } from "../assets";
import AssetLoader from "../helper/asset-loader";
import ExpositionRendering from "../rendering/ExpositionRendering";
import ShadowGenerator = BABYLON.ShadowGenerator;

export default class Link {
  mesh: AbstractMesh

  constructor(name: string, position: Vec3, assetLoader: AssetLoader, scene: BABYLON.Scene, shadowGenerator: ShadowGenerator) {
    this.mesh = loadAsset(assetLoader, name, AssetIdentifiers.MODEL_INFO, new Vec3(0.15, 0.15, 0.15), position);
    const material = new BABYLON.StandardMaterial("linkMaterial", scene);
    material.diffuseColor = BABYLON.Color3.FromHexString('#4c619c');
    this.mesh.material = material;

    ExpositionRendering.addShadows(this.mesh, shadowGenerator);
  }

  rotate() {
    this.mesh.rotate(BABYLON.Axis.Y, 0.01);
  }
}
